var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"cover-icon",class:_vm.customClass},[(_vm.useImgIcon)?_c('img',{staticClass:"icon-image",attrs:{"src":_vm.icon.image}}):(_vm.useEmojiIcon)?_c('icon',{attrs:{"icon":_vm.realIconName,"height":_vm.defaultHeight,"color":_vm.color}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }